import React from "react";

export default (params) => {  
  return (
    <a href={params.data.imp_amazonLink} target="_blank">
      {params.data.imp_ASIN}
    </a>
  );
};
